import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Chip, Divider, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Tab, Tabs, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
import Global from '../../../customlib/Global';
class LeadsBelumAdaLabelMobile extends Component {
    state = {

     } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Leads Belum Ada Label"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <TextField
                                    id="dateStart"
                                    label="Tanggal Leads"
                                    type="date"
                                    defaultValue={this.props.state.startDate}
                                    onChange={this.props.handleStartDateChange}
                                    // className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth={true}
                                    size='small'
                                />
                            </Grid>
                        </Grid>
                    </Filter>

                    {
                        <Chip sx={{mb: "10px"}} label={`Total belum diberi label : ${this.props.state.totalLeads} leads`} />
                    }

                    {
                    this.props.state.contactLeads?.map((group, indexGroup) => {
                        return group.leads.map((lead, index) => {
                            return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <Typography component="span">{lead.fromName}</Typography>
                                        </Grid>
                                        <Grid item xs={8} textAlign={"left"} sx={{pr: "5px"}}>
                                            {lead.assignToUserName}
                                        </Grid>
                                        <Grid item xs={4} textAlign={"left"} sx={{pr: "5px"}}>
                                            {Global.formatDateTimeToStrDate(lead.created_at)}
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Paper elevation={0} sx={{mb: "0px", padding: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Nomor</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {Global.maskPhoneNumber(lead.from)}
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Chat Terakhir</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {Global.formatDateTimeToStrDateTime24(lead.lastMessageReceivedAt)}
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1} >
                                            <Grid item xs={6}>
                                                <strong>Tanggal Kirim</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {Global.formatDateTimeToStrDateTime24(lead.deliveryDate)}
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1} sx={{mt: "10px"}}>
                                            <Grid item xs={12} textAlign={"right"} sx={{pr: "5px"}}>
                                                <Button fullWidth variant='contained' color='error' onClick={() => {this.props.handleShowMessages(lead.contactFormatted)}}>Buka Chat</Button>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </AccordionDetails>
                            </Accordion>
                        );
                        })
                        
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default LeadsBelumAdaLabelMobile;